module.exports = __webpack_public_path__ + "static/illustration-1-532d1235d3c32bd7ddf58e24a532c8c0.jpg";